export default __webpack_public_path__ + "static/media/ionic-react.d2141474.svg";